export default function getDefaultSataliaCampaignSettings(): {
    assetType: "IMAGE" | "VIDEO";
} {
    return {
        assetType: "IMAGE"
    };
}
